import { domain } from "../../domain";

export const FETCH_ITEMS_REQUEST = 'FETCH_ITEMS_REQUEST';
export const FETCH_ITEMS_SUCCESS = 'FETCH_ITEMS_SUCCESS';
export const FETCH_ITEMS_FAILURE = 'FETCH_ITEMS_FAILURE';

export const FETCH_PRODUCT_TYPES_REQUEST = 'FETCH_PRODUCT_TYPES_REQUEST';
export const FETCH_PRODUCT_TYPES_SUCCESS = 'FETCH_PRODUCT_TYPES_SUCCESS';
export const FETCH_PRODUCT_TYPES_FAILURE = 'FETCH_PRODUCT_TYPES_FAILURE';


export const fetchProducts = () => {
  return async dispatch =>{
    //Start Loading
    dispatch(
      {
        type : FETCH_ITEMS_REQUEST,
      });

    try{
      var requestOptions = {
      method: 'GET',
      redirect: 'follow'
      };
    
      fetch(`${domain}/api/product-cust/`, requestOptions)
      .then(response => response.text())
        .then(result => {
          result = JSON.parse(result);
          result.sort((a, b) => a.id - b.id);
          dispatch(
            {
              type : FETCH_ITEMS_SUCCESS,
              payload:result,
            }
          );
        })
        .catch(error =>{
          dispatch(
            {
              type : FETCH_ITEMS_FAILURE,
              payload:error,
            }
          );
        })
    }
    catch{

    }
  }
}

export const fetchProductsTypes = () => {
  return async dispatch =>{
    //Start Loading
    dispatch(
      {
        type : FETCH_PRODUCT_TYPES_REQUEST,
      });

    try{
      var requestOptions = {
      method: 'GET',
      redirect: 'follow'
      };
    
      fetch(`${domain}/api/product-types/`, requestOptions)
      .then(response => response.text())
        .then(result => {          
          result = JSON.parse(result);
          const filteredResult = result.filter(type => type.name !== "AdditionalItem");
          filteredResult.sort((a, b) => a.id - b.id);
          dispatch(
            {
              type : FETCH_PRODUCT_TYPES_SUCCESS,
              payload:filteredResult,
            }
          );
        })
        .catch(error =>{
          dispatch(
            {
              type : FETCH_PRODUCT_TYPES_FAILURE,
              payload:error,
            }
          );
        })
    }
    catch{

    }
  }
}